module.exports = __webpack_public_path__ + "static/media/info-delivery.e2044967.svg";